import { useState, useEffect } from 'react';

export const useDeviceOS = () => {
  const [os, setOs] = useState({
    // Mobile OS
    isAndroid: false,
    isIOS: false,
    // Desktop OS
    isWindows: false,
    isMac: false,
    isLinux: false,
    // General info
    currentOS: 'Unknown',
    deviceType: 'Unknown', // 'Mobile' or 'Desktop'
  });

  useEffect(() => {
    // Ensure window/navigator exists (for SSR/Next.js safety)
    if (typeof window !== 'undefined' && window.navigator) {
      const ua = window.navigator.userAgent;

      // Mobile OS detection
      const isAndroid = /Android/i.test(ua);
      const isIOS = /iPhone|iPad|iPod/i.test(ua);

      // Desktop OS detection
      const isWindows = /Windows|Win32|Win64|WinCE/i.test(ua);
      const isMac = /Macintosh|MacIntel|MacPPC|Mac68K|Darwin|iPhone|iPad|iPod/i.test(ua) && !/Windows/i.test(ua);
      const isLinux = /Linux|X11|Ubuntu|Debian|Fedora|CentOS/i.test(ua) && !/Android/i.test(ua);

      let currentOS = 'Unknown';
      let deviceType = 'Unknown';

      // Determine current OS and device type
      if (isAndroid) {
        currentOS = 'Android';
        deviceType = 'Mobile';
      } else if (isIOS) {
        currentOS = 'iOS';
        deviceType = 'Mobile';
      } else if (isWindows) {
        currentOS = 'Windows';
        deviceType = 'Desktop';
      } else if (isMac) {
        currentOS = 'macOS';
        deviceType = 'Desktop';
      } else if (isLinux) {
        currentOS = 'Linux';
        deviceType = 'Desktop';
      }

      setOs({
        isAndroid,
        isIOS,
        isWindows,
        isMac,
        isLinux,
        currentOS,
        deviceType,
      });
    }
  }, []);

  return os;
};
